import { axiosInstance } from '../../axios';
import { ChatFile } from './file.interface';

export function uploadChatFile(messageId: string, file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return axiosInstance
    .post<ChatFile>(`/api/file/${messageId}`, formData)
    .then((response) => response.data);
}

export function downloadChatFile(fileId: string) {
  return axiosInstance
    .get<Blob>(`/api/file/${fileId}`, { responseType: 'blob' })
    .then((response) => response.data);
}
